export const ExpenseColumnType = {
  DATE: 'DATE',
  CATEGORY: 'CATEGORY',
  EXPENSE_AMOUNT: 'EXPENSE_AMOUNT',
  EXPENSE_CURRENCY: 'EXPENSE_CURRENCY',
  FX_CURRENCY: 'FX_CURRENCY',
  RATE: 'RATE',
  CLAIM_AMOUNT: 'CLAIM_AMOUNT',
  COMMENT: 'COMMENT',
  RECEIPT: 'RECEIPT',
  RECEIPT_SAVE: 'RECEIPT_SAVE',
  RECEIPT_DELETE: 'RECEIPT_DELETE'
};
